declare namespace $ {

	export class $mol_icon_security extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=security.view.tree.d.ts.map